module.exports = __webpack_public_path__ + "img/wt4.cc389752.png";